import createIfmsApi from './ifmsApi';

function createApi() {
  return createIfmsApi();
}

export default createApi;
